import React, { Fragment } from "react";
import { BrowserRouter as Router, Route, Routes as RouterRoutes } from "react-router-dom";
import Routes from "./components/routing/Routes";

import "./App.css";
import ApplicationProvider from "./contexts/app.provider";
import ParticipantRoutes from "./components/routing/participant/Routes";
import { ParticipantAuthProvider } from "./contexts/participant-auth.context";
import { InvitationPage } from "./pages/invitationPage";
import { PublicLayout } from "./components/layout/public/PublicLayout";
import { ParticipantRoute } from "./components/routing/participant/ParticipantRoute";
import { ScrollToTop } from "./utils/ScrollToTop";
import { AppStatsProvider } from "./contexts/stats.context";

export default function App(): React.ReactElement {
    return (
        <Router
            future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
            }}
        >
            <Fragment>
                <RouterRoutes>
                    <Route
                        path="/"
                        element={
                            <ParticipantAuthProvider>
                                <ParticipantRoute
                                    isPublic
                                    layout={PublicLayout}
                                    component={() => <InvitationPage isSignIn />}
                                />
                            </ParticipantAuthProvider>
                        }
                    />
                    <Route
                        path="/*"
                        element={
                            <ParticipantAuthProvider>
                                <ParticipantRoutes />
                            </ParticipantAuthProvider>
                        }
                    />
                </RouterRoutes>

                <RouterRoutes>
                    <Route
                        path="/*"
                        element={
                            <ApplicationProvider>
                                <ScrollToTop />
                                <AppStatsProvider>
                                    <Routes />
                                </AppStatsProvider>
                            </ApplicationProvider>
                        }
                    />
                </RouterRoutes>
            </Fragment>
        </Router>
    );
}
